import { Component, Input, OnInit } from '@angular/core';
import { News } from '../../model/news.model';
import { UsersServiceProvider } from '../../../core/services/users-service/users-service';
import { UserDisplay } from '../../../core/services/users-service/interfaces/user-display.interface';
import { ConfigServiceProvider } from '../../../core/services/config-service/config-service';

@Component({
  selector: 'app-news-icon',
  templateUrl: 'news-icon.html',
})
export class NewsIconComponent implements OnInit {
  @Input() news: News;
  @Input() size: string;
  private author: UserDisplay;
  public bgColor: string;
  public imageUrl: string;

  constructor(private usersService: UsersServiceProvider) {}

  ngOnInit() {
    const users = this.usersService.getUsersProperty();
    this.author = users && users[this.news.params.author];

    if (this.news.newsIcon !== null) {
      this.bgColor = this.news.newsIcon.backgroundColor;
      this.imageUrl = this.getNewsIconUrl();
    } else this.imageUrl = this.getAutorPhotoUrl();
  }

  private getNewsIconUrl(): string {
    if (!this.news || !this.news.newsIcon || !this.news.newsIcon.icon) return '';
    return this.news.newsIcon.icon;
  }

  private getAutorPhotoUrl(): string {
    if (!this.author || !this.author.photo) return '';
    return this.author.photo;
  }
}



// WEBPACK FOOTER //
// ./src/modules/news/components/news-icon/news-icon.ts